import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPresorteoEditComponent } from './config-presorteo-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ModelRangeGnaEditModule } from '../../model-range-gna/model-range-gna-edit/model-range-gna-edit.module';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import {AccordionModule} from 'primeng/accordion';



@NgModule({
  declarations: [
    ConfigPresorteoEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    ToastModule,
    AccordionModule,
    ModelRangeGnaEditModule,
  ], exports: [
    ConfigPresorteoEditComponent
  ]
})
export class ConfigPresorteoEditModule { }
